import { Resume } from 'packages/types'
import { SettingsFieldChangeHandler } from '../../../../../modules/resumeEditor'
import { SelectValue } from '../../../../Select/types'
import { useTemplateCustomization } from './useTemplateCustomization'

const FALLBACK_DATE_FORMAT = 'LLL yyyy'

export function useDateFormatCustomisation(
  resume: Resume,
  onFieldChange?: SettingsFieldChangeHandler,
) {
  const { currentTemplate, resumeSpecificTemplateSettings } = useTemplateCustomization(resume)

  return {
    value:
      resumeSpecificTemplateSettings?.dateFormat ??
      currentTemplate?.settings?.dateFormat?.default ??
      FALLBACK_DATE_FORMAT,
    isDisabled: !currentTemplate?.supportsDateFormatCustomization,
    options: currentTemplate?.settings?.dateFormat?.values || [],
    onSelect: (newValue: SelectValue) => {
      if (typeof newValue !== 'string') return
      onFieldChange?.('dateFormat', newValue, currentTemplate?.settings?.dateFormat?.default)
    },
  }
}
